export const getNavLink = (searchParams: URLSearchParams, path = 'menu') => {
  const table = searchParams.get('table')
  if (table) {
    return `/${path}?table=${table}`
  } else {
    return `/${path}`
  }
}
